import $ from 'jquery';

let activityCreateController = (_ => {
    const inputField = document.getElementById("pac-input");
    const mapElement = document.getElementById('map');
    const latField = $('input[name=lat]');
    const lonField = $('input[name=lon]');
    const location = { // default is Den Bosch (markt)
        lat: latField.val() === '' ? 51.689073 : parseFloat(latField.val()),
        lng: lonField.val() === '' ? 5.303866 : parseFloat(lonField.val()),
    };

    const obj = {
        inputs: {
            zip: $('input[name=zip]'),
            address: $('input[name=address]'),
            city: $('input[name=city]'),
            country: $('input[name=country]'),
            lat: latField,
            lon: lonField,
        },
        location: location,
        map: new google.maps.Map(mapElement, {
            center: location,
            zoom: 14
        }),
        autocomplete: new google.maps.places.Autocomplete(inputField, {
            fields: ["address_components", "geometry", "name"],
            componentRestrictions: {country: ['nl', 'be', 'de']}
        }),
        marker: null,
        init() {
            this.marker = new google.maps.Marker({position: location, map: this.map, draggable: true});

            this.autocomplete.setComponentRestrictions({
                country: ["us", "pr", "vi", "gu", "mp"],
            });

            this.autocomplete.addListener("place_changed", () => {
                const location = this.autocomplete.getPlace();

                this.location = location.geometry.location;

                this.updateMap();
                this.parseAddressComponents(location.address_components);
                this.updateLatLonFields();
            });

            google.maps.event.addListener(this.marker, "drag", _ => {
                this.location = this.marker.getPosition();
                this.updateLatLonFields();
            });
        },
        updateMap() {
            this.marker.position = this.location;

            this.marker.setPosition(this.location);
            this.map.panTo(this.location);
        },
        updateLatLonFields() {
            this.inputs.lat.val(this.location.lat);
            this.inputs.lon.val(this.location.lng);
        },
        parseAddressComponents(components) {
            const data = {postal_code: null, locality: null, route: null, street_number: null, country: null};
            for (let component of components) {
                for (let type of component.types) {
                    if (data.hasOwnProperty(type)) {
                        data[type] = component.long_name;
                    }
                }
            }

            this.inputs.city.val(data.locality);
            this.inputs.zip.val(data.postal_code);
            this.inputs.address.val(data.route + ' ' + data.street_number);
            this.inputs.country.val(data.country);
        }
    };

    obj.init();

    return obj;
});

window.initMapActivityCreate = function () {
    activityCreateController();
}
